import React, { useState } from 'react'
import './index.css'

interface Props {
	onSubmit: (pin: string) => void;
	loading: boolean;
	error: string | null;
}

const PinLoginForm: React.FC<Props> = ({ onSubmit, loading, error }) => {
	const [pin, setPin] = useState<string>('')

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (pin.trim()) {
			onSubmit(pin.trim())
		}
	}

	return (
		<form className='pin-login-form' onSubmit={handleSubmit}>
			<div className='pin-input-container'>
				<input
					type='text'
					value={pin}
					onChange={(e) => setPin(e.target.value)}
					placeholder='Unesite PIN'
					className='pin-input'
					disabled={loading}
					autoFocus
				/>
			</div>

			{error && <p className='pin-error'>{error}</p>}

			<button
				type='submit'
				className='pin-submit-btn'
				disabled={loading || !pin.trim()}
			>
				{loading ? 'Prijava...' : 'Prijava'}
			</button>
		</form>
	)
}

export default PinLoginForm
